import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import swal from "sweetalert2";

import { validateTransert } from '../../../../actions/app/mpt/weeks';

import './Card.css';

class CardResult extends React.Component {
    constructor(props) {
        super();
        this.state = {
            lastname: props.card.lastname,
            club: props.card.destinations.d0 ? props.card.destinations.d0.club.clubName : 'Not specified',
            status: props.card.valid ? 'OFFICIEL' : 'EN ATTENTE',
            destination: props.card.valid && props.card.destinations[props.card.valid.destination] ?
                `${props.card.valid.destination}_${props.card.destinations[props.card.valid.destination].id === 'd6' ? 
                    'Autre' 
                    : props.card.destinations[props.card.valid.destination].club.clubName}`
                : '',
            clubSelected: null,
            price: props.card.valid && props.card.valid.id !== 'd0' ? props.card.valid.price : '',
            d6Choice: props.card.valid && props.card.valid.destination === 'd6',
            selectClub: props.card.valid && props.card.valid.destination === 'd6' ?
                `${props.card.valid.club.clubName}_${props.card.valid.club.id}` : null,
        };
    }

    submit(id, cardId) {
        const { dispatch } = this.props;
        const { price, clubSelected, selectClub } = this.state;
        const club = document.getElementById(id);
        let destination;
        if (!clubSelected && club && price) {
            destination = club.value ? club.value.split('_')[0] : null;
            if (destination === 'd6') {
                let clubId;
                if (!selectClub) clubId = document.getElementById(`clubDest${cardId}`).value;
                else clubId = selectClub;
                clubId = `${clubId.split('_')[1]}_${clubId.split('_')[2]}_${clubId.split('_')[3]}`;
                this.setState({ d6Choice: true });
                dispatch(validateTransert({ destination, price, clubId }, cardId.split('_')[0], cardId));
            } else {
                destination && dispatch(validateTransert({ destination, price }, cardId.split('_')[0], cardId));
            }
        } else if (price) {
            destination = clubSelected.split('_')[0];
            if (destination === 'd6') {
                const clubId = `${selectClub.split('_')[1]}_${selectClub.split('_')[2]}_${selectClub.split('_')[3]}`;
                this.setState({ d6Choice: true });
                dispatch(validateTransert({ destination, price, clubId }, cardId.split('_')[0], cardId));
            } else {
                dispatch(validateTransert({destination, price}, cardId.split('_')[0], cardId));
            }
        } else {
            destination = club.value ? club.value.split('_')[0] : null;
            if (destination === 'd0') {
                dispatch(validateTransert({destination}, cardId.split('_')[0], cardId));
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const { card } = this.props;
        if (nextProps.state.app.mpt.weeks.info.error) {
            swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong, error: "${nextProps.state.app.mpt.weeks.info.error}" <br />Try again`
            });
        }
        if (card !== nextProps.card) {
            this.setState({
                lastname: nextProps.card.lastname,
                club: nextProps.card.destinations.d0 ? nextProps.card.destinations.d0.club.clubName : 'Not specified',
                status: nextProps.card.valid ? 'OFFICIEL' : 'EN ATTENTE',
                destination: nextProps.card.valid && nextProps.card.destinations[nextProps.card.valid.destination] ?
                    `${nextProps.card.valid.destination}_${nextProps.card.destinations[nextProps.card.valid.destination].id === 'd6' ?
                        'Autre'
                        : nextProps.card.destinations[nextProps.card.valid.destination].club.clubName}`
                    : '',
                clubSelected: null,
                price: nextProps.card.valid && nextProps.card.valid.id !== 'd0' ? nextProps.card.valid.price : '',
                d6Choice: nextProps.card.valid && nextProps.card.valid.destination === 'd6',
                selectClub: nextProps.card.valid && nextProps.card.valid.destination === 'd6' ?
                    `${nextProps.card.valid.club.clubName}_${nextProps.card.valid.club.id}` : null,
            })
        }
    }

    changeDest(t) {
        if (t.target.value === 'd6_Autre') {
            this.setState({ d6Choice: true });
        } else{
            this.setState({ clubSelected: t.target.value, d6Choice: false });
        }
    }

    render() {
        const { card, clubsList } = this.props;
        const { lastname, club, status, price, destination, d6Choice, selectClub } = this.state;
        return(
            <tr>
                <th>{lastname}</th>
                <th>{club}</th>
                <th>{status}</th>
                <th>
                    <select
                        className="selectDest"
                        id={`cardId${card.id}`}
                        defaultValue={destination}
                        onChange={(t) => this.changeDest(t)}
                    >
                        {
                            map(card.destinations, dest => {
                                return (
                                    <option
                                        key={dest.id}
                                    >
                                        {dest.club.clubName ? `${dest.id}_${dest.club.clubName}` : 'd6_Autre'}
                                    </option>
                                )
                            })
                        }
                    </select>
                    {
                        d6Choice &&
                        <select
                            className="selectDest"
                            id={`clubDest${card.id}`}
                            defaultValue={selectClub}
                            onChange={(t) => this.setState({ selectClub: t.target.value })}
                        >
                            {
                                map(clubsList, club => {
                                    // console.log(club);
                                    return (
                                        <option
                                            key={club.id}
                                        >
                                            {`${club.clubName}_${club.id}`}
                                        </option>
                                    );
                                })
                            }
                        </select>
                    }
                </th>
                <th>
                    <input
                        className="text-center"
                        value={price}
                        onChange={(t) => this.setState({ price: t.target.value })}
                    />
                </th>
                <th>
                    <button
                        className="btn-success"
                        onClick={() => this.submit(`cardId${card.id}`, card.id)}
                    >
                        OK
                    </button>
                </th>
            </tr>
        );
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
)(CardResult);



// WEBPACK FOOTER //
// ./src/pages/MPT/Results/Card/index.js